/* ============================================================
   NURSE CORNER — product page interactions (Shopify / Dawn)
   Safe to load on every page: every block guards its own elements.
   Cart + checkout are handled natively by Shopify's product form,
   so there is NO custom add-to-cart logic here.
   ============================================================ */
(function () {
  "use strict";

  function init(root) {
    root = root || document;

    /* ---------- gallery thumbnail swap ---------- */
    root.querySelectorAll("[data-nc-gallery]").forEach(function (gallery) {
      var mainImg = gallery.querySelector("[data-nc-main]");
      var thumbs = gallery.querySelectorAll(".thumb");
      thumbs.forEach(function (t) {
        t.addEventListener("click", function () {
          var src = t.getAttribute("data-full") || (t.querySelector("img") && t.querySelector("img").src);
          if (mainImg && src) {
            mainImg.style.opacity = "0";
            setTimeout(function () {
              mainImg.src = src;
              var alt = t.querySelector("img");
              if (alt) mainImg.alt = alt.alt;
              mainImg.style.opacity = "1";
            }, 180);
          }
          thumbs.forEach(function (x) { x.setAttribute("aria-current", "false"); });
          t.setAttribute("aria-current", "true");
        });
      });
    });

    /* ---------- accordions ---------- */
    root.querySelectorAll(".acc__head").forEach(function (head) {
      head.addEventListener("click", function () {
        var item = head.closest(".acc__item");
        var panel = item.querySelector(".acc__panel");
        if (item.classList.contains("open")) {
          item.classList.remove("open");
          panel.style.maxHeight = "0px";
        } else {
          item.classList.add("open");
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
      // open-by-default items get their height set on load
      var item = head.closest(".acc__item");
      if (item.classList.contains("open")) {
        var panel = item.querySelector(".acc__panel");
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });

    /* ---------- sticky buy bar (shows once the buy box scrolls off) ---------- */
    var buyBox = root.querySelector("[data-nc-buybox]");
    var sticky = root.querySelector("[data-nc-sticky]");
    if (buyBox && sticky && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // show the bar only while the buy box is NOT visible and we've scrolled past it
          var past = e.boundingClientRect.bottom < 0;
          sticky.classList.toggle("show", !e.isIntersecting && past);
        });
      }, { threshold: 0 });
      io.observe(buyBox);
    }

    /* ---------- reviews pagination (static fallback widget only) ---------- */
    root.querySelectorAll("[data-nc-reviews]").forEach(function (widget) {
      var list = widget.querySelector(".jdgm-list");
      var pagi = widget.querySelector(".jdgm-pagi");
      if (!list || !pagi) return;
      var reviews = Array.prototype.slice.call(list.querySelectorAll(".jdgm-rev"));
      var links = Array.prototype.slice.call(pagi.querySelectorAll("a[data-page]"));
      var pages = Array.from(new Set(reviews.map(function (r) { return r.dataset.page || "1"; }))).sort();
      var current = "1";

      function showPage(page) {
        current = page;
        reviews.forEach(function (r) { r.hidden = (r.dataset.page || "1") !== page; });
        links.forEach(function (a) { a.classList.toggle("is-active", a.dataset.page === page); });
      }
      links.forEach(function (a) {
        a.addEventListener("click", function (e) {
          e.preventDefault();
          var target = a.dataset.page;
          if (target === "next") {
            var i = pages.indexOf(current);
            target = pages[Math.min(i + 1, pages.length - 1)];
          }
          showPage(target);
          widget.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });
      showPage("1");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }

  /* re-init blocks rendered by the theme editor */
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();